<template>
  <g>
    <path
      d="M18 12.0002C18 12.5502 18.45 13.0002 19 13.0002H21C21.55 13.0002 22 12.5502 22 12.0002C22 11.4502 21.55 11.0002 21 11.0002H19C18.45 11.0002 18 11.4502 18 12.0002Z"
    />
    <path
      d="M16.59 16.8203C16.26 17.2603 16.35 17.8703 16.79 18.1903C17.32 18.5803 17.88 19.0003 18.41 19.4003C18.85 19.7303 19.47 19.6403 19.79 19.2003C19.79 19.1903 19.8 19.1903 19.8 19.1803C20.13 18.7403 20.04 18.1203 19.6 17.8003C19.07 17.4003 18.51 16.9803 17.99 16.5903C17.55 16.2603 16.93 16.3603 16.6 16.8003C16.6 16.8103 16.59 16.8203 16.59 16.8203Z"
    />
    <path
      d="M19.81 4.81029C19.81 4.80029 19.8 4.80029 19.8 4.79029C19.47 4.35029 18.85 4.26029 18.42 4.59029C17.89 4.99029 17.32 5.41029 16.8 5.81029C16.36 6.14029 16.28 6.76029 16.61 7.19029C16.61 7.20029 16.62 7.20029 16.62 7.21029C16.95 7.65029 17.56 7.74029 18 7.41029C18.53 7.02029 19.09 6.59029 19.62 6.19029C20.05 5.87029 20.13 5.25029 19.81 4.81029Z"
    />
    <path
      d="M8 9.00024H4C2.9 9.00024 2 9.90024 2 11.0002V13.0002C2 14.1002 2.9 15.0002 4 15.0002H5V18.0002C5 18.5502 5.45 19.0002 6 19.0002C6.55 19.0002 7 18.5502 7 18.0002V15.0002H8L13 18.0002V6.00024L8 9.00024Z"
    />
    <path
      d="M15.5 12.0003C15.5 10.6703 14.92 9.47027 14 8.65027V15.3403C14.92 14.5303 15.5 13.3303 15.5 12.0003Z"
    />
  </g>
</template>
